import {
  GKButton,
  GKModal,
  GKSearchSelect,
  Grid2,
  ReloadIcon,
} from "components";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store/store";
import { GKModalProps } from "utils/commonInterface";

const FetchInvoiceModal = (props: GKModalProps) => {
  const { open, setOpen } = props;

  const navigate = useNavigate();

  const partner = useAppSelector((state) => state?.app?.partnerList);

  const [selectPartner, setSelectPartner] = useState(null);

  const handleNavigate = (path: string) => navigate(path);

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle="Add Commission"
      width={"580px"}
      footer={
        <GKButton
          variant="contained"
          startIcon={<ReloadIcon />}
          onClick={() =>
            handleNavigate(`/app/revenue/commission/${selectPartner}/invoices`)
          }
        >
          Fetch Unpaid Commissions
        </GKButton>
      }
    >
      <Grid2 container py={1}>
        <GKSearchSelect
          inputLabel="Partner Name"
          placeholder="Select Partner Name"
          options={partner}
          getOptionLabel={(opt) => opt?.name || opt}
          onChange={(event, val) => setSelectPartner(val?.value || null)}
          value={
            partner.find((item) => item.value === selectPartner)?.name || null
          }
        />
      </Grid2>
    </GKModal>
  );
};

export default FetchInvoiceModal;
